import { useEffect } from "react";
import { ContainerV2, H1, P, PaymentCodContainerV2, InfoV2 } from "../../Atoms";
import { Tracking } from "../../../services/Tracking";
import { maskMoney } from "../../../utils/masks";
import { useTicketV2 } from "./useTicketV2";

export const TicketV2 = () => {
  const { stepIndicator, pagamento, acessarFatura } = useTicketV2();

  useEffect(() => {
    Tracking.pageView("mapa:agendamento/pagamento/boleto:pageview");
  }, []);

  return (
    <>
      <ContainerV2
        backButton={false}
        nextButton={{
          title: "Ver Fatura",
          onClick: acessarFatura,
        }}
      >
        {stepIndicator}
        <H1 className="mb-4 mt-8">Pagamento</H1>
        <P className="mb-8 text-[#666666]">
          Após a aprovação você irá definir a data e horário.
        </P>

        <div className="flex flex-col items-center gap-8">
          <img
            src={pagamento?.boleto?.barCode}
            alt="codigo de barras"
            className="h-[100px] w-full max-w-[706px] rounded-[10px] border border-solid border-[#20332f] object-contain"
          />

          <p className="font-['Mulish'] text-base font-bold text-black">
            Valor: {maskMoney((pagamento?.valorTotal ?? 0) / 100)}
          </p>

          <PaymentCodContainerV2 value={pagamento?.boleto?.barCodeData ?? ""} />
        </div>
      </ContainerV2>
      <InfoV2 className="w-full max-w-7xl mx-auto" required>
        O pagamento em <strong>boleto pode levar até 3 dias úteis</strong> para
        confirmação.
        <br />
        Mas não se preocupe, avisaremos via <strong>WhatsApp</strong> assim que
        der tudo certo.
      </InfoV2>
    </>
  );
};
